<template>
  <section class="w-full flex items-center justify-center border"  >
    <div class="relative w-full h-full flex justify-center items-center cursor-pointer" @click="isModalShow = true">
      <NuxtImg
        sizes="xs:100vw, sm:100vw, md:100vw, lg:100vw, xl:100vw, xxl:100vw, '2xl':100vw"
        width="1000"
        height="1000"
        loading="lazy"
        format="webp"
        quality="100"
        :src="item.img"
        class="w-full rounded-md overflow-hidden"
        :alt="alt"
      />
      <span class="flex justify-center absolute items-center fill-white bg-blue-600 w-8 h-8 laptop:w-32 laptop:h-32 aspect-square rounded-full">
        <IconPlay class=" w-2/5 relative ml-1"/>
      </span>
    </div>
    <SectionModalVideo :src="item.video" :isShow="isModalShow" @close="isModalShow = false"  />
  </section>
</template>

<script setup>
defineProps({
  item: Object,
  alt: String
})
const isModalShow = ref(false)

</script>
